// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// React
import { useState, useEffect, useRef } from 'react';

// Material UI
import {
  Box,
  Dialog,
  DialogTitle,
  Stack,
  IconButton,
  Typography,
} from "@mui/material";

// Icons
import CloseIcon from '@mui/icons-material/Close';
import SettingsVoiceIcon from '@mui/icons-material/SettingsVoice';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';

// Custom Components
import DeviceList from '../mediaDevices/DeviceList';
import VideoCanvas from '../mediaDevices/VideoCanvas';

// Custom Scripts
import { useMediaDevices } from '../../scripts/video/devices.js';



// ----------------------------------------------------------------------------
//   Component: Selection Content
// ----------------------------------------------------------------------------


export function SelectDeviceContent({ webcam, direction = "row" }) {

  // Track available devices
  const [ devices ] = useMediaDevices();

  // Component
  return (
      <Stack direction={ direction } maxWidth="100%" marginTop={2} position="relative" minHeight="0">

        <Stack direction="column" flex={1} height={ direction === "row" ? "100%" : "50%" }>
          <Typography component="h4" variant="h6" textAlign="center">
            Video
          </Typography>
          <Box flex={1} sx={{
            "overflow-y": "scroll",
            "overflow-x": "hidden",
          }}>
            <DeviceList
              devices  = { devices.value?.video }
              onSelect = { webcam.setVideoDevice }
              selected = { webcam.getVideoDevice() }
              showIDs  = { false }
              listStyles = {{
                pt: 0,
                pb: 0,
                minHeight: direction === "column" ? "100%" : null,
              }}
              icon = {<VideoCameraFrontIcon fontSize='small' sx={{ marginLeft: "1px" }} />}
            />
          </Box>
        </Stack>

        <Stack direction="column" flex={1} height={ direction === "row" ? "100%" : "50%" }>
          <Typography component="h4" variant="h6" textAlign="center">
            Audio
          </Typography>
          <Box flex={1} sx={{
            "overflow-y": "scroll",
            "overflow-x": "hidden",
          }}>
            <DeviceList
              devices  = { devices.value?.audio }
              onSelect = { webcam.setAudioDevice }
              selected = { webcam.getAudioDevice() }
              showIDs  = { false }
              listStyles = {{
                pt: 0,
                pb: 0,
                minHeight: direction === "column" ? "100%" : null,
              }}
              icon = {<SettingsVoiceIcon fontSize='small' />}
            />
          </Box>
        </Stack>

      </Stack>
  )
}



// ----------------------------------------------------------------------------
//   Component: Selection Dialog
// ----------------------------------------------------------------------------

export function SelectDeviceDialog({ webcam, onClose, open }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true} maxWidth="lg"
      PaperProps={{sx: {"overflow-y": "hidden", height: "95%", maxHeight: "95%"}}}
    >

      <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" component="h5">
          Webcam Settings
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Box flex={1} maxHeight="60%">
        <VideoCanvas videoRef={ webcam.getRef() } />
      </Box>

      <SelectDeviceContent
        webcam = { webcam }
        direction = "row"
      />

    </Dialog>
  )
}
